module.exports = __webpack_public_path__ + "icon-64x64.a066138d.png";